<script setup lang="ts">
import RefundsContainer from './containers/RefundsContainer.vue'
</script>

<template>
  <RefundsContainer />
</template>
